import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ServicingBaseComponent } from '@common/components';
import { CommonLibService } from '@lib/services';

@Component({
  selector: 'asw-informative-seatmap-sub-header',
  templateUrl: './informative-seatmap-sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InformativeSeatmapSubHeaderComponent extends ServicingBaseComponent {
  constructor(private _commonLibService: CommonLibService) {
    super(_commonLibService);
  }

  override init(): void {}
  override reload(): void {}
  override destroy(): void {}
}
